import { Control, FieldValues } from "react-hook-form";

import { TextFieldProps } from "@mui/material";

import { FormSelectField } from "../FormSelectField";

import { organizationTypeOption } from "./utils";

type Props<TValue extends FieldValues> = Omit<TextFieldProps, "variant"> & {
  control: Control<TValue>;
  name?: string;
  label?: React.ReactNode;
  placeholder?: string;
  optional?: boolean;
  fontSize?: number;
  labelFontSize?: number;
};

export const FormPolicyholderOrganizationRelationshipSelect = <
  TValue extends FieldValues,
>({
  control,
  name = "repRelationToOrg",
  label = "Rep relationship to organization",
  placeholder = "Select...",
  optional = false,
  disabled = false,
  fontSize,
  labelFontSize,
}: Props<TValue>) => {
  return (
    <FormSelectField
      id="organization-type"
      dataTestId="organization-input"
      name={name}
      control={control}
      options={organizationTypeOption}
      label={label}
      placeholder={placeholder}
      optional={optional}
      disabled={disabled}
      fontSize={fontSize}
      labelFontSize={labelFontSize}
      fullWidth
    />
  );
};
